import React from "react";
import { Box, Typography } from "@mui/material";

/** Read-only label + value (view mode — not a disabled input). */
export default function DetailField({ label, value, children }) {
    return (
        <Box sx={{ py: 0.75 }}>
            <Typography
                component="div"
                variant="caption"
                sx={{ color: "#5c6570", fontWeight: 600, display: "block", mb: 0.25 }}
            >
                {label}
            </Typography>
            {children ?? (
                <Typography
                    component="div"
                    sx={{ fontSize: 15, color: "#1c2430", fontWeight: 500, lineHeight: 1.45 }}
                >
                    {value != null && value !== "" ? value : "—"}
                </Typography>
            )}
        </Box>
    );
}
